/** Runtime connection chip — Production/Development + sockets vs poll. Never "demo" or "test". */
export function businessRuntimeLabel(input: { production: boolean; socketsLive: boolean }): string {
  const environment = input.production ? 'Production' : 'Development';
  const transport = input.socketsLive ? 'Live sockets' : 'Polling';
  return `${environment} · ${transport}`;
}
